import MetricsCounter from "./MetricsCounter";

export default MetricsCounter;
